import { render, staticRenderFns } from "./sourceConfig.vue?vue&type=template&id=b020b97c&scoped=true"
import script from "./sourceConfig.vue?vue&type=script&lang=js"
export * from "./sourceConfig.vue?vue&type=script&lang=js"
import style0 from "./sourceConfig.vue?vue&type=style&index=0&id=b020b97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b020b97c",
  null
  
)

export default component.exports